// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__y1bSD","title":"Header_title__1HPmA","left":"Header_left__iI3pH","clinicName":"Header_clinicName__2PbI3"};